import { Card, CardActionArea, CardContent, Grid, Typography } from '@mui/material'

import { IScorecardResponse } from '../types'

export type ScorecardCardKey = 'k1' | 'k1b' | 'k2' | 'k3' | 'k4' | 'k5' | 'k6'

interface IProps {
  data: IScorecardResponse
  onCardClick?(key: ScorecardCardKey): void
}

const fmt = new Intl.NumberFormat('pt-BR')
const pct = (v: number) => `${v.toFixed(1)}%`

export function Scorecard({ data, onCardClick }: IProps) {
  const cards: Array<{ key: ScorecardCardKey; title: string; value: string; hint?: string }> = [
    { key: 'k1', title: 'Total de pessoas', value: fmt.format(data.total_pessoas_base), hint: 'K1 — base endereçável' },
    { key: 'k1b', title: 'Vidas ativas', value: fmt.format(data.total_vidas_ativas), hint: 'K1b — com vínculo ativo' },
    { key: 'k2', title: 'Endereçáveis', value: fmt.format(data.total_enderecaveis), hint: `K2 • ${pct(data.pct_enderecabilidade)} de K1` },
    { key: 'k3', title: 'Elegíveis c/ plano', value: fmt.format(data.total_elegiveis_com_plano), hint: `K3 • ${pct(data.pct_conversao)} de K2` },
    { key: 'k4', title: 'Movimentações pendentes', value: fmt.format(data.movimentacoes_pendentes), hint: 'K4' },
    { key: 'k5', title: 'Aprovações no período', value: fmt.format(data.aprovacoes_periodo), hint: 'K5' },
    { key: 'k6', title: 'Alertas ativos', value: fmt.format(data.alertas_ativos), hint: 'K6' },
  ]

  const clickableKeys: ScorecardCardKey[] = ['k4']

  return (
    <Grid container spacing={2}>
      {cards.map(c => {
        const clickable = onCardClick && clickableKeys.includes(c.key)
        const body = (
          <CardContent>
            <Typography variant="overline" color="text.secondary">{c.title}</Typography>
            <Typography variant="h4" sx={{ fontWeight: 600 }}>{c.value}</Typography>
            {c.hint && <Typography variant="caption" color="text.secondary">{c.hint}</Typography>}
          </CardContent>
        )
        return (
          <Grid item xs={12} sm={6} md={3} lg={3} key={c.key}>
            <Card variant="outlined">
              {clickable ? (
                <CardActionArea onClick={() => onCardClick?.(c.key)}>{body}</CardActionArea>
              ) : body}
            </Card>
          </Grid>
        )
      })}
    </Grid>
  )
}
